import { Component, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationDto, NOTIFICATION_TYPES } from '../../../notifications/notification.service';

@Component({
  selector: 'app-notifications-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notifications-panel.component.html',
  styleUrl: './notifications-panel.component.scss',
})
export class NotificationsPanelComponent {
  @Input() notifications: NotificationDto[] = [];
  @Input() loading: boolean = false;

  @Output() reviewStatusChange = new EventEmitter<NotificationDto>();
  @Output() notificationClick = new EventEmitter<NotificationDto>();
  @Output() downloadDocument = new EventEmitter<NotificationDto>();

  readonly NOTIFICATION_TYPES = NOTIFICATION_TYPES;

  constructor(public el: ElementRef<HTMLElement>) {}

  trackById(_i: number, n: NotificationDto) {
    return n.id;
  }
  isUnread(n: NotificationDto): boolean {
    return (n.notification_status || '').toUpperCase() === 'NEW';
  }

  onReviewStatusChange(notification: NotificationDto) {
    this.reviewStatusChange.emit(notification);
  }

  onNotificationClick(notification: NotificationDto, _event: MouseEvent) {
    // Emit event to parent component for handling mark as read and navigation
    this.notificationClick.emit(notification);
  }

  onDownloadDocument(notification: NotificationDto, event: MouseEvent) {
    event.stopPropagation();
    this.downloadDocument.emit(notification);
  }

  isFileRequestNotification(notification: NotificationDto): boolean {
    return notification.notification_type === NOTIFICATION_TYPES.B_AND_CS_FILE_REQUEST;
  }

  isDdqUnderReviewNotification(notification: NotificationDto): boolean {
    return notification.notification_type === NOTIFICATION_TYPES.DDQ_UNDER_REVIEW;
  }

  isLoaFileRequestNotification(notification: NotificationDto): boolean {
    return notification.notification_type === NOTIFICATION_TYPES.LOA_FILE_REQUEST;
  }

  isSignatoryListNotification(notification: NotificationDto): boolean {
    return notification.notification_type === NOTIFICATION_TYPES.SIGNATORY_LIST_NEW_VERSION;
  }

  isSigningProcessCompleteNotification(notification: NotificationDto): boolean {
    return notification.notification_type === NOTIFICATION_TYPES.SIGNING_PROCESS_COMPLETE;
  }

  isStatusChangeRequestNotification(notification: NotificationDto): boolean {
    return (
      notification.notification_type === NOTIFICATION_TYPES.BCR_STATUS_CHANGE_REQUEST &&
      notification.message?.includes('request-approval needed.')
    );
  }
}
